export { SearchService } from './service-setup/SearchService';

import { diContainer, serviceNames } from './service-setup/diContainer';

diContainer.get(serviceNames.searchService).register();
